/* ============================================================
   IDEAS CAFE — Collection behaviour

   Two progressive enhancements over markup that already works
   without JavaScript:

     facets      the filter form submits normally with no JS; here
                 it becomes an async fetch that swaps the grid and
                 updates history
     load more   the "next page" anchor becomes an append-in-place
                 button; the numbered links stay in the DOM for
                 crawlers and are hidden visually
   ============================================================ */
(function () {
  'use strict';

  var grid = document.querySelector('[data-product-grid]');
  var facets = document.querySelector('[data-facets]');
  var pagination = document.querySelector('[data-pagination]');

  /* ── Shared: swap a region from a fetched document ─────── */

  function fetchDoc(url, signal) {
    return fetch(url, { signal: signal })
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
  }

  /* ── Facets ────────────────────────────────────────────── */

  if (facets && grid) {
    var pending = null;

    var applyFacets = function () {
      var params = new URLSearchParams(new FormData(facets));

      // FormData omits unchecked boxes, which is exactly the filter
      // semantics we want — but empty values would still serialise,
      // so drop them.
      var clean = new URLSearchParams();
      params.forEach(function (value, key) {
        if (value !== '') clean.append(key, value);
      });

      var url = window.location.pathname + (clean.toString() ? '?' + clean.toString() : '');

      if (pending) pending.abort();
      var controller = new AbortController();
      pending = controller;

      grid.setAttribute('aria-busy', 'true');

      fetchDoc(url, controller.signal)
        .then(function (doc) {
          var freshGrid = doc.querySelector('[data-product-grid]');
          var freshControls = doc.querySelector('[data-facets]');
          var freshCount = doc.querySelector('.ideas-collection__count');
          var freshPagination = doc.querySelector('[data-pagination]');

          if (freshGrid) grid.replaceWith(freshGrid);
          else {
            // No grid in the response means zero matches — swap in
            // whatever the server rendered instead.
            var freshEmpty = doc.querySelector('.ideas-collection__empty');
            if (freshEmpty) grid.replaceWith(freshEmpty);
          }

          // Re-render the facets themselves: counts and disabled
          // states change with every selection.
          // Keep the scroll position of a one-row filter strip, so the
          // pill just tapped doesn't jump out of view.
          if (freshControls) {
            var keepScroll = facets.scrollLeft;
            facets.innerHTML = freshControls.innerHTML;
            facets.scrollLeft = keepScroll;
            // The pills' widths changed; let the arrows re-check.
            facets.dispatchEvent(new Event('scroll'));
          }

          var count = document.querySelector('.ideas-collection__count');
          if (freshCount && count) count.textContent = freshCount.textContent;

          var pag = document.querySelector('[data-pagination]');
          if (pag) {
            if (freshPagination) pag.replaceWith(freshPagination);
            else pag.remove();
          }

          window.history.replaceState({}, '', url);

          grid = document.querySelector('[data-product-grid]');
          pagination = document.querySelector('[data-pagination]');
          bindLoadMore();
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          console.warn('[ideas] facet update failed', err);
          // Fall back to a full navigation rather than stranding the
          // customer with stale results.
          window.location.href = url;
        })
        .then(function () {
          pending = null;
          var g = document.querySelector('[data-product-grid]');
          if (g) g.removeAttribute('aria-busy');
        });
    };

    facets.addEventListener('change', applyFacets);
    facets.addEventListener('submit', function (e) {
      e.preventDefault();
      applyFacets();
    });

    // One-row filter strip: a plain mouse wheel only scrolls
    // vertically, so turn it sideways while the strip has somewhere to
    // go. At either end the page scrolls as normal.
    facets.addEventListener('wheel', function (e) {
      if (!facets.closest('.ideas-collection--facets-scroll')) return;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return; // trackpad: native
      var max = facets.scrollWidth - facets.clientWidth;
      if (max <= 0) return;
      var atStart = facets.scrollLeft <= 0 && e.deltaY < 0;
      var atEnd = facets.scrollLeft >= max - 1 && e.deltaY > 0;
      if (atStart || atEnd) return;
      e.preventDefault();
      facets.scrollLeft += e.deltaY;
    }, { passive: false });
  }

  /* ── Load more ─────────────────────────────────────────── */

  function bindLoadMore() {
    var container = document.querySelector('[data-pagination]');
    if (!container) return;

    var button = container.querySelector('[data-load-more]');
    if (!button || button.dataset.bound === 'true') return;

    button.dataset.bound = 'true';
    container.classList.add('is-enhanced');

    button.addEventListener('click', function (event) {
      event.preventDefault();
      if (button.dataset.busy === 'true') return;

      var url = button.getAttribute('href');
      if (!url) return;

      button.dataset.busy = 'true';
      var restore = button.textContent;
      button.textContent = button.dataset.labelLoading || restore;

      fetchDoc(url)
        .then(function (doc) {
          var currentGrid = document.querySelector('[data-product-grid]');
          var freshGrid = doc.querySelector('[data-product-grid]');
          if (currentGrid && freshGrid) {
            // Append rather than replace, so already-loaded rows stay
            // put and scroll position is preserved.
            while (freshGrid.firstElementChild) {
              currentGrid.appendChild(freshGrid.firstElementChild);
            }
          }

          var freshPagination = doc.querySelector('[data-pagination]');
          var freshNext = freshPagination
            ? freshPagination.querySelector('[data-load-more]')
            : null;

          if (freshNext) {
            button.setAttribute('href', freshNext.getAttribute('href'));
            button.textContent = restore;
            button.dataset.busy = 'false';
          } else {
            // Last page reached.
            container.remove();
          }

          window.history.replaceState({}, '', url);
        })
        .catch(function (err) {
          console.warn('[ideas] load more failed', err);
          button.textContent = restore;
          button.dataset.busy = 'false';
        });
    });
  }

  bindLoadMore();
})();
